import React from 'react';
import DaumPostcode from 'react-daum-postcode';

const SetAddress = ({handleAddress}) => {
    return (
        <div>
            <DaumPostcode
                onComplete={handleAddress}
            />
        </div>
    )
}

export default SetAddress;